export const withBasePath = (pathSegment: string): string =>
  `${document.location.origin}${process.env.PUBLIC_URL}${pathSegment}`;
